<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_mode')}}:
								| {{ $i18n.t('trainer.trainer_gameFormSetting_' + settings.mode) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
								| {{ settings.numOfExamples }}
						br
						template(v-for='(theme, index) in settings.themes')
								span(:key='theme + index')
										| {{ $i18n.t('trainer.trainer_gameFormSetting_themesForExample', {example: index + 1}) }}:
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + theme.first) + ", " + $i18n.t('trainer.trainer_gameFormSettingValue_' + theme.second)}}
								br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
